<template>
    <div class="toggler-button list-toggler" :class="{active: isActive}">
        <a data-toggle="pill" href="#list-wrapper" data-placement="bottom" :title="title" @click="eventHandler">
            <b-icon :icon="icon" scale="1.2" aria-hidden="true"></b-icon>
        </a>
    </div>
</template>

<script>

    /**
     * Custom pseudo button.
     * Switches the map and the table sub views bellow.
     */

    export default {
        name: "TogglerButton",
        props: {
            icon: String,
            title: String,
            isActive: Boolean,
            eventHandler: Function
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/variables";
    
        /* general styles for buttons that apply for all */
    .toggler-button {
        /* flex behavior and center V/H icons */
        display: -ms-inline-flexbox;
        display: -webkit-inline-flex;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        /* dimensions and spacing */
        width: 36px;
        height: 36px;
        opacity: 1;
        border-radius: 5px;
        margin-left: 4%;
        cursor: pointer;
    }

    .toggler-button {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.161);
    }

    .toggler-button.active {
        background: #8781CA 0% 0% no-repeat padding-box;
        box-shadow: 0px 1px 8px rgba(59, 66, 217, 0.412);
    }

    /* handle hover */
    .toggler-button:hover {
        outline: 0;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
        box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
    }

    /* --------------- anchor in toggler btn -------------- */
    .toggler-button a {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        outline: none;
    }

    /* icon in ACTIVE toggler button */
    .toggler-button.active a svg {
        color: #FFFFFF;
    }

    /* icons in toggler buttons */
    .toggler-button a svg {
        font-size: 20px;
        color: #B6B6B6;
    }

        /* -------- fixes for mobile ---------- */
    @media screen and (max-width: 762px) {
        .toggler-button {
            width: 31px;
            height: 31px;
        }
    }

</style>